import styles from "../member.module.scss";
import type { Member } from "../_data/members";
import Avatar from "./Avatar";

type MemberCardProps = {
  member: Member;
  // 経歴を持つ人だけパネルを開ける。経歴が無い人は押せる要素にしない。
  onOpen?: (member: Member) => void;
  priority?: boolean;
};

export default function MemberCard({
  member,
  onOpen,
  priority,
}: MemberCardProps) {
  const body = (
    <>
      <div className={styles.cardPhoto}>
        <Avatar member={member} variant="card" priority={priority} />
      </div>
      <h3 className={styles.cardName}>{member.name}</h3>
      <span className={styles.cardRole}>{member.role}</span>
    </>
  );

  if (!onOpen) {
    return <div className={`${styles.card} fade-up`}>{body}</div>;
  }

  return (
    <button
      type="button"
      className={`${styles.card} ${styles.cardClickable} fade-up hover-target`}
      onClick={() => onOpen(member)}
      aria-label={`${member.name}のプロフィールを開く`}
    >
      {body}
      <span className={styles.cardMore} aria-hidden="true">
        VIEW PROFILE
      </span>
    </button>
  );
}
